<template>
  <input class="currency-component" type="text" v-model="displayValue" @blur="isInputActive = false" @focus="isInputActive = true" :disabled="disabled"/>
</template>
<script>
export default {
  name: 'ComponentCurrencyInput',
  props: {
       value: {

       },
       min: Number,
       max: Number,
       disabled: Boolean
  },
  data: function() {
    return {
      isInputActive: false
    }
  },
  computed: {
    displayValue: {
      get: function() {
        if (this.isInputActive) {
          return this.value ? this.value.toString() : ''
        } else {
          let value = ''
          if (!isNaN(this.value) && this.value !== null) {
            value = this.formatNumberToCurrency(this.value)
          } else if (this.value === 0) {
            value = '0'
          } else {
            value = ''
          }
          return value
        }
      },
      set: function(modifiedValue) {
        let newValue = Number(modifiedValue.replace(/[, ]/g, "").toString())
        // Ensure that it is not NaN
        if (isNaN(newValue)) {
          newValue = 0
        }
        if(this.min && newValue < this.min){
          newValue = this.min
        }
        if(this.max && newValue > this.max){
          newValue = this.max
        }
        this.$emit('input', newValue)
        this.$emit('change', newValue)
      }
    }
  },
  methods: {
    formatNumberToCurrency(number) {
      const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: Math.min(2, Math.max(0, this.getDecimalCount(number))),
        maximumFractionDigits: this.getDecimalCount(number)
      });

      return formatter.format(number);
    },

    getDecimalCount(number) {
      if (!Number.isFinite(number)) {
        return 0;
      }

      const parts = number.toString().split('.');

      return parts.length > 1 ? parts[1].length : 0;
    }
  }
}
</script>